import { Indetity } from './identity';

export const ServerEvents = { Indetity };
